
/*

*/

import { IAuth as ia, INewAccount as Ina, CAuth, CNewAccount } from '../typed/auth';
import { IUser as iu, CUser } from '../typed/user';
import { IAccount as iac, CAccount } from '../typed/account';
import { IWorkstyle as iw, CWorkstyle } from '../typed/workstyle';

export type IAuth = ia;
export type INewAccount = Ina;
export type IUser = iu;
export type IAccount = iac;
export type IWorkstyle = iw;

export {
  CAuth,
  CUser,
  CAccount,
  CNewAccount,
  CWorkstyle,
};

export interface VAuth {
  auth: IAuth;
}

export interface VApp {
  appData: IAPP;
}

export interface VDisp {
  disp: string;
}

export interface IAPP {
  name: string;
  mail: string;
  role: number;
  contractStatus: string;
  isRegistered: boolean;
  username: string;
}

export class CApp implements IAPP {
  public name = '';
  public mail = '';
  public role = 0;
  public contractStatus = '';
  public isRegistered = false;
  public username = '';
}



